import React from "react";
import Seo from "../../components/seo";
import Industry from "../../layouts/Industries/Industry";
import {graphql, useStaticQuery} from 'gatsby';
import Layout from "../../components/layout";
import {Pharmacies} from '../../components/svgs/industries';

const OthersIndustriesPageFr = () => {
  const data = useStaticQuery(graphql`
    query OthersIndustriesDatasFr {
      allContentfulSecteurs(filter: {contentful_id: {eq: "70OA8GcVMObd2NwScKZ0IC"}}) {
        edges {
          node {
            name
            permalink
            contentful_id
            advantages {
              title
              description
              icon
              visual {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
            installations {
              gatsbyImageData(layout: CONSTRAINED)
            }
            clients {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)

  return (
    <Layout 
    slider={false} 
    switchLink={data.allContentfulSecteurs.edges[1].node.permalink} 
    lang="fr-CA"
    title={data.allContentfulSecteurs.edges[0].node.name} 
    subTitle="L'affichage dynamique en"
    icon={<Pharmacies/>}>
      <Seo 
        title="Gestion d'affichage numérique pour toute occasion"
        description="Des contenus adaptés à vos clients, une planification pour intéresser votre clientèle et l'utilisation optimale de vos écrans pour diffuser facilement tout ce que vous avez en tête."
       />
      <Industry datas={data.allContentfulSecteurs.edges[0].node}/>
    </Layout>
  )
}

export default OthersIndustriesPageFr
